<template >
    <div class="form-group table-responsive col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-4">
        <table id="list-student-table" cellspacing="0" width="100%" class="table table-bordered table-striped table-head-fixed" >
            <thead>
                <tr>
                    <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Sl.No.</th>
                    <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Student Name</th>
                    <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Cid No</th>
                    <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Date of Birth</th>
                    <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Class</th>
                    <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Date of Application</th>
                    <th style='font-weight: bold;font-family: "Times New Roman", Times, serif'>Admission Type</th>
                    <th style='font-weight: bold;font-family: "Times New Roman", Times, serif;width:20%'>Action</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(std, index) in stdList" :key="index">
                    <td>{{ index + 1 }} </td>
                    <td>{{ std.FirstName }} {{ std.MiddleName }} {{ std.LastName}}</td>
                    <td>{{ std.CidNo}} </td>
                    <td>{{ std.DateOfBirth}}</td>
                    <td>{{ std.class_id}}</td>
                    <td>{{ std.DateOfApply }}</td>
                    <td>{{ std.AdmissionType=='New'? "New Registration":'Old Student'}}</td>
                    <td style="width:20%">
                        <a href="#" class="btn btn-info btn-sm btn-flat text-white" @click="loadeditpage(std)"><span clas="fa fa-eye"></span>Apply School</a>
                        <!-- <a href="#" class="btn btn-info btn-sm btn-flat text-white" @click="Takeaction(std)"><span clas="fa fa-eye"></span>Accept/Reject</a> -->
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
export default {
    components: {
    },
    data() {
        return {
            stdList:[],
            dt:'',
            class_form: new form({
                dzongkhag:'',
                org:'',
                class:'',
                stream:'',
                section:'',
            }),
        }
    },
    methods: {
        loadeditpage(data){
            this.$router.push({name:"edit_admission_request",params:{data:data}});
        },
        Takeaction(data){
            this.$router.push({name:"action_admission",params:{data:data}});
        },
        loadStudentList(param){
            this.stdList =[];
            let uri="";
                uri='admissions/loadStudentList/'+param;
                axios.get(uri)
                .then(response => {
                    let data = response.data.data;
                    this.stdList = data;
                });
        },
        /**
         * method to remove fields
         */
        remove(type,id){
            Swal.fire({
                text: "Please confirm your decision",
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes!',
            }).then((result) => {
                if(result.isConfirmed){
                    axios.get('admissions/deleteclassDetails/'+id+'__'+type)
                    .then((response) => {
                        this.loadStudentList('session');
                    })
                    .catch((error) => {
                        console.log("Error remove:"+error);
                    })
                }
            });
        },

    },
   async mounted(){
        axios.get('getSessionDetail')
        .then(response => {
            let data = response.data.data;
            this.userId=data.id;;
            this.loadStudentList(this.userId)
        })
        // this.dt =  $("#list-student-table").DataTable();
        this.dt = $("#list-student-table").DataTable({
            "order": [[ 0, "asc" ]],
            "lengthChange": false,
            "searching": false,
        }) 
    },

    watch: {
        stdList() {
            this.dt.destroy();
            this.$nextTick(() => {
                this.dt =  $("#list-student-table").DataTable()
            });
        }
    },
}
</script>
